(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hamels-app-text-cleanup"] && !Shopify.designMode) return;
  try {
    function clearLeakedCountryBlockerText() {
    document.querySelectorAll('country-blocker[data-block-handle="country-blocker"]').forEach((element) => {
      [...element.childNodes].forEach((node) => {
        if (
          node.nodeType === Node.TEXT_NODE &&
          node.textContent.includes('"blockAnalyticsEvents"=>') &&
          node.textContent.includes('data-apiurl="https://country-blocker.devoptly.com"')
        ) {
          node.remove();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', clearLeakedCountryBlockerText, { once: true });
  } else {
    clearLeakedCountryBlockerText();
  }
  } catch(e) { console.error(e); }
})();

})();
